import React from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import moment from 'moment';
import { makeStyles } from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';


const useStyles = makeStyles((theme) => ({
    container: {
        display: 'flex',
        flexWrap: 'wrap',
    },
    textField: {
        marginTop: '1rem',
    },
}));

const TextFieldDatePicker = (props) => {
    const { className, type, defaultValue, InputLabelProps, ...rest } = props;
    const classes = useStyles();
    return (
        <TextField
            type={type}
            defaultValue={defaultValue}
            className={clsx(classes.textField, className)}
            InputLabelProps={InputLabelProps}
            inputProps={{ max: '9999-01-01' }}
            {...rest}
        />
    );
};

TextFieldDatePicker.propTypes = {
    className: PropTypes.string,
    type: PropTypes.string,
    defaultValue: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    InputLabelProps: PropTypes.object,
};

TextFieldDatePicker.defaultProps = {
    className: '',
    type: 'date',
    defaultValue: moment().format('DD/MM/YYYY'),
    InputLabelProps: { shrink: true }
};

export default TextFieldDatePicker;